<template>
  <div id="shop-items-all-companies-modal">

    <memlist-modal ref="all-shop-items-modal" size="xl" :ok-title="$t('COMMON.SAVE')" hide-footer>
      <ShopItemsAllCompaniesTable 
        @selected="selected_item"
      />
    </memlist-modal>

  </div>
</template>

<script>

import axios from 'axios';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';

import dayjs from 'dayjs';
import ShopItemsAllCompaniesTable from './ShopItemsAllCompaniesTable.vue';

export default {
  name: 'ShopItemsAllCompaniesModal',
  components: {
    ShopItemsAllCompaniesTable
  },
  mixins: [toasts],
  computed: {

  },
  props: ['todo'],
  emits: ['selected'],
  watch: {

  },
  async mounted() {

  },
  methods: {
    selected_item(item) {
      this.$emit('selected', item);
    },

    show() {
      this.$refs['all-shop-items-modal'].show();
    },

    hide() {
      this.$refs['all-shop-items-modal'].hide();
    },
  },
  data() {
    return {
      success_text_message: null,
      success_header_message: null,
    };
  },
};
</script>
<style lang="scss" scoped>

</style>
